import "../style.css";
import { switchMorePhoto } from "./fnHelperMorePhoto";

const MorePhoto = ({ props, handleImageClick }) => {
  return (
    <>
      {props?.images?.length > 5 && (
        <button
          style={switchMorePhoto(props)}
          className="more-photo"
          onClick={() => handleImageClick(4)}
        >
          Еще фото
        </button>
      )}
    </>
  );
};

export { MorePhoto };
